export const isoStandard = (number: number, isFixed?: any | boolean | undefined): string => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: isFixed && 2,
    maximumFractionDigits: isFixed && 2,
    useGrouping: true,
  }).format(number);
};
